import React from "react";
import { Link } from "react-router-dom";
import { PageHero, CTAButton } from "../components/Shared";

export default function NotFound() {
  return (
    <>
      <PageHero eyebrow="404" title="This page took a different shipment." intro="The page you're looking for isn't here. Let's get you back on track." />
      <section className="bg-white py-20 text-center sm:py-28">
        <div className="mx-auto max-w-xl px-5">
          <CTAButton to="/" testId="notfound-home">Back to Home</CTAButton>
          <p className="mt-6 text-sm text-brand-gray">
            Or <Link to="/contact" className="font-semibold text-brand-red underline underline-offset-4">contact our team</Link>.
          </p>
        </div>
      </section>
    </>
  );
}
